import { VRSphere } from '../engine/VRSphere';
import { SCENE_EVENTS } from '../MVC/Model';

export const SPHERE_CONTROLLER_LOADER = {
  ERROR_TILE_LOADING: "ERROR_TILE_LOADING"
};

export default class SphereController {
  constructor({ scene, camera, model }) {
    this.model = model;
    this.scene = scene;
    this.camera = camera;
    this.vrSpheres = {};
    this.userExitingApp = false;

    this.model.addEventListener(SCENE_EVENTS.START_SCENE_CHANGE, (data) => { this.startSceneChange(data) });
    this.model.addEventListener(SCENE_EVENTS.STOP_SCENE_CHANGE, () => { this.stopSceneChanged() });
    this.model.addEventListener(SCENE_EVENTS.START_ANIMTAION_OUTRO, () => { this.userExitingApp = true });

    model.sceneData.scenes.forEach((sceneData) => {
      this.createSphereForScene(sceneData);
    });

    // Set the currentSphere to the one corresponding to the current scene
    this.currentSphere = this.vrSpheres[model.currentScene.id];
  }

  createSphereForScene(scene) {
    const rot = this.model.editMode ? 0 : (scene.sceneRotationY || 0);
    const vrSphere = new VRSphere({
      scene: this.scene,
      camera: this.camera,
      model: this.model,
      rot,
      background: scene.background
    });
    this.vrSpheres[scene.id] = vrSphere;
  }

  startSceneChange(data) {
    // Access the current sphere directly using the scene ID from the event data
    const currentSphere = this.vrSpheres[this.model.currentScene.id];
    if (currentSphere) {
      currentSphere.startSceneChange(data.background);
    }
    // Update the currentSphere reference to the new one
    this.currentSphere = this.vrSpheres[data.id];
    Object.values(this.vrSpheres).forEach((vrSphere) => {
      vrSphere.sphereGroup.visible = false;
    });
  }

  stopSceneChanged() {
    // Access the current sphere directly using the scene ID
    const currentSphere = this.vrSpheres[this.model.currentScene.id];
    if (currentSphere) {
      currentSphere.stopSceneChanged();
    }
  }

  updateSphereSegments() {
    if (this.userExitingApp) {
      return;
    }
    // Update segments of the current sphere
    if (this.currentSphere) {
      this.currentSphere.updateSphereSegments();
      this.currentSphere.sphereGroup.visible = true;
    }
  }
}
